export class EditionLayerStyles {
    hasTextStyle(): any {
      return typeof(this.mida_etiqueta) !== 'undefined' 
        && typeof(this.color_etiqueta) !== 'undefined' 
        && this.mida_etiqueta.length>0 
        && this.color_etiqueta.length>0
    }
    public color_interior: string;
    public radi_punt?: number;
    public color_border?: string;
    public mida_border?: number;
    public mida_etiqueta?: string;
    public color_etiqueta?: string;
}


// WEBPACK FOOTER //
// /home/jenkins-agent/workspaces/workspace/enmapa-gis-mob-frontend/src/app/models/edition-layer-styles.ts